<template>
  <v-container fluid v-if="album && album.length>0">
    <v-row>
      <v-col cols="4">
        <v-img :src="$assets.meeroThumbnail(order.id, album[0].id)" height="350"></v-img>
      </v-col>
      <v-col cols="8">
        <h3 class="subtitle">Téléchargez vos photos</h3>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, quibusdam.</p>
        <v-btn small class="themed" :to="'/orders/view/'+order.id+'/album'">VOIR L'ALBUM</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters("album", ["album"])
  },
  mounted() {
    if (
      this.order.job &&
      ["ready", "medias_selected", "delivered"].includes(this.order.job.status)
    ) {
      this.getAlbum(this.order.id);
    }
  },
  methods: {
    ...mapActions("album", ["getAlbum", "getImage"])
  }
};
</script>

<style>
</style>